<div class="is-flex is-direction-column gap-8">
  <div class="label is-flex">
    <ng-content select="app-dataset-card-label"></ng-content>
  </div>
  <div class="value">
    <ng-content></ng-content>
  </div>
</div>
<ng-content select="app-dataset-card-preview"></ng-content>
